module.exports = __webpack_public_path__ + "img/Mint.8f54b782.jpg";